import { useState } from 'react';
import { Stack, Title, Text, Button, Group, Paper, Alert } from '@mantine/core';
import { api } from '../../wheel-api/client';
import { getStandToken, setStandToken, clearStandToken } from '../../wheel-api/stand';
import { TecladoNumerico } from './TecladoNumerico';

/**
 * Armado de la tablet del stand (ruleta §9). Sin token, las pantallas de
 * entrega y encuentro no se muestran: sus endpoints entregan caravanas y
 * acuñan códigos de descuento.
 */
export function StandGate({ children }) {
  const [armada, setArmada] = useState(Boolean(getStandToken()));
  const [pin, setPin] = useState('');
  const [error, setError] = useState(null);
  const [enviando, setEnviando] = useState(false);

  async function armar() {
    setEnviando(true);
    setError(null);
    try {
      const r = await api.standArmar(pin);
      setStandToken(r.token);
      setArmada(true);
    } catch (err) {
      clearStandToken();
      setError(err.data?.message || 'No pudimos armar la tablet.');
      setPin('');
    } finally {
      setEnviando(false);
    }
  }

  if (armada) return children;

  return (
    <Stack align="center" justify="center" style={{ flex: 1 }} gap="lg" px="10%">
      <Stack align="center" gap={4}>
        <Title order={2} ta="center" c="forvet.7" style={{ fontSize: 'clamp(22px, 3.6vh, 38px)' }}>
          ARMAR LA TABLET
        </Title>
        <Text size="lg" c="forvet.6" ta="center">
          Pedile el PIN al encargado del stand
        </Text>
      </Stack>

      <Paper withBorder radius="lg" p="lg" style={{ width: 320 }}>
        <TecladoNumerico value={pin} onChange={v => { setPin(v); setError(null); }} maxLen={6} />
      </Paper>

      {error && <Alert color="red" radius="md" style={{ maxWidth: 420 }}>{error}</Alert>}

      <Group>
        <Button h={72} w={280} loading={enviando} disabled={pin.length < 4} onClick={armar}>
          ARMAR
        </Button>
      </Group>
    </Stack>
  );
}
